// extracted by mini-css-extract-plugin
module.exports = {"organization-details":"styles_organization-details__2En-6"};